import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  productItems: yup.array().of(
    yup.object().shape({
      "Product name": yup.string().required("Product name is required"),
      "Product category": yup.string().required("Category is required"),
      "Stores ID": yup.string().required("Store ID is required"),
    }),
  ),
});

export const useValidation = ({ productItems }) => {
  const normalized = Array.isArray(productItems)
    ? productItems
    : productItems && typeof productItems === "object"
      ? Object.values(productItems)
      : [];

  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      productItems: normalized,
    },
  });
};
